/**
 * HomeSLHomeComposeDemoView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeSLHomeComposeDemo
 */

import { useHomeSLHomeComposeDemoLogic } from '@/hooks/traits/useHomeSLHomeComposeDemoLogic';
import type { HomeSLHomeComposeDemoConfig } from '@/hooks/traits/useHomeSLHomeComposeDemoLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeSLDemoComposeTask } from '@app/shared';
import { Split } from '@almadar/ui/components';
import { HomeSLDemoComposeEquationView } from '@/components/traits/HomeSLDemoComposeEquationView';
import { HomeSLDemoComposeTourView } from '@/components/traits/HomeSLDemoComposeTourView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface HomeSLHomeComposeDemoViewProps {
  config?: Partial<HomeSLHomeComposeDemoConfig>;
}

export function HomeSLHomeComposeDemoView({ config: propsConfig }: HomeSLHomeComposeDemoViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeSLHomeComposeDemoLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeSLDemoComposeTask'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeSL" trait="HomeSLHomeComposeDemo">
      {slotWriter['main'] === 'INIT' ? (<Split align="start" gap="xl" ratio="1:3"><HomeSLDemoComposeEquationView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><HomeSLDemoComposeTourView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Split>) : null}
    </TraitScopeProvider>
  );
}

export default HomeSLHomeComposeDemoView;
